export default {
  LOGIN: '@LOGIN/LOGIN',
  LOGIN_SUCCESS: '@LOGIN/LOGIN_SUCCESS',
  LOGIN_FAILURE: '@LOGIN/LOGIN_FAILURE',
  LOGOUT: '@LOGIN/LOGOUT',
  DID_TRY_AUTOLOGIN: '@LOGIN/DID_TRY_AUTOLOGIN'
}
